export const queryKeys = {
  schools: {
    all: ['schools'] as const,
    catalog: ['schools', 'catalog'] as const,
    detail: (slug: string) => ['schools', slug] as const,
  },
  courses: {
    all: ['courses'] as const,
    list: (schoolSlug?: string) => ['courses', { schoolSlug }] as const,
    detail: (id: string) => ['courses', id] as const,
  },
  lessons: {
    detail: (id: string) => ['lessons', id] as const,
    related: (id: string) => ['lessons', id, 'related'] as const,
  },
  batches: {
    all: ['batches'] as const,
    detail: (id: string) => ['batches', id] as const,
  },
  assignments: {
    batch: (batchId: string) => ['assignments', 'batch', batchId] as const,
    take: (assignmentId: string) => ['assignments', assignmentId, 'take'] as const,
    review: (assignmentId: string) => ['assignments', assignmentId, 'review'] as const,
  },
  enrollments: {
    batch: (batchId: string) => ['enrollments', 'batch', batchId] as const,
  },
  schedules: {
    batch: (batchId: string) => ['schedules', 'batch', batchId] as const,
  },
  community: {
    channels: ['community', 'channels'] as const,
    threads: (channelId: string) => ['community', 'threads', channelId] as const,
    thread: (threadId: string) => ['community', 'thread', threadId] as const,
  },
  dashboard: {
    overview: ['dashboard', 'overview'] as const,
  },
  progress: {
    bySchool: ['progress', 'bySchool'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
  },
  reminders: {
    all: ['reminders'] as const,
  },
  certificates: {
    all: ['certificates'] as const,
  },
  quizzes: {
    detail: (id: string) => ['quizzes', id] as const,
    mine: ['quizzes', 'mine'] as const,
    take: (quizId: string) => ['quizzes', quizId, 'take'] as const,
    attempts: (quizId: string) => ['quizzes', quizId, 'attempts'] as const,
  },
  flashcards: {
    deck: (id: string) => ['flashcards', id] as const,
  },
  admin: {
    users: ['admin', 'users'] as const,
    teachers: ['admin', 'teachers'] as const,
    schools: ['admin', 'schools'] as const,
    batches: ['admin', 'batches'] as const,
    analytics: ['admin', 'analytics'] as const,
    payments: ['admin', 'payments'] as const,
    moderation: ['admin', 'moderation'] as const,
  },
  ai: {
    conversations: ['ai', 'conversations'] as const,
  },
  auth: {
    me: ['auth', 'me'] as const,
  },
} as const;
